import React from 'react';

import { NotificationChannel } from '@frontend/common';
import SelectInputV2, { SelectInputV2Props } from '../select/select-input-v2/select-input-v2.component';
import useNotificationChannelSelect from './notification-channel-select.controller';

const ID = 'notification-channel-select';

export interface NotificationChannelSelectProps extends Omit<SelectInputV2Props<NotificationChannel>, 'options'> {
 
}

export const NotificationChannelSelect = (props: NotificationChannelSelectProps) => {
    const viewProps = useNotificationChannelSelect(props);

    return (
        <SelectInputV2
            id={props.id || ID}
            label={props.label || 'Notification channel'}
            className={props.className}
            required={props.required}
            options={viewProps.options}
            onSelect={props.onSelect}
            value={viewProps.value}
            disabled={props.disabled}
            isClearable={props.isClearable}
        />
    );
};
